const ComponentSignature = {
  SELECT: Symbol('select'),
  OPTION_GROUP: Symbol('option-group'),
  OPTION: Symbol('option'),
  DIVIDER: Symbol('divider'),
};

export { ComponentSignature };
